module.exports = __webpack_public_path__ + "img/bg1.a7797a8e.png";